import { useEffect, useRef } from 'react';

export function useReveal(options = {}) {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, ...options });

    // Observe all .reveal children or the element itself
    const targets = el.querySelectorAll('.reveal');
    if (targets.length > 0) {
      targets.forEach(t => observer.observe(t));
    } else {
      el.classList.add('reveal');
      observer.observe(el);
    }

    return () => observer.disconnect();
  }, []);

  return ref;
}
